import React from 'react'
import { Link } from 'react-router-dom'

function News() {
  return (
    <div className='news-container'>
        <h1>News</h1>

    </div>
  )
}

export default News